/**
 * The midterms hub root, only ever linked under /category/elections. Lives here
 * so the navbar can link it without pulling `midtermsRoutes` into the shell.
 */
export const MIDTERMS_BASE_PATH = '/category/elections/midterms';

/**
 * The hub is Kalshi's one midterms page: the pages that compete with it for "midterm predictions"
 * searches link to it with this anchor text, so the signal consolidates on the hub.
 */
export const MIDTERMS_HUB_ANCHOR_TEXT = '2026 midterm predictions';

/**
 * The biggest midterm markets by search traffic — Senate control, House control and balance of
 * power — whose event pages link to the hub. Exact tickers, not series: the same series list other
 * cycles' elections (`CONTROLS-2028`) and pre-election snapshots, which this hub isn't about.
 */
export const MIDTERMS_HUB_LINKED_EVENT_TICKERS: ReadonlySet<string> = new Set([
    'CONTROLS-2026',
    'CONTROLH-2026',
    'KXBALANCEPOWERCOMBO-27FEB',
]);

/** Red-to-blue text gradient that marks midterms entry points across the nav chrome. */
export const MIDTERMS_TEXT_GRADIENT = 'linear-gradient(to right, #FF4D6A, #408FFF)';

// The `[slug]` segment serves the hub under every category slug, not just elections.
const MIDTERMS_HUB_PATH_PATTERN = /^\/category\/[^/]+\/midterms(?:\/|$)/;

/** Whether a pathname renders the midterms hub, on any of its tabs. */
export function isMidtermsHubPath(pathname: string): boolean {
    return MIDTERMS_HUB_PATH_PATTERN.test(pathname);
}

/** Statsig gate controlling trader-count visibility across the midterms hubs. */
export const SHOW_TRADER_COUNTS_GATE = 'show_trader_counts';

/**
 * Event behind the governor hub's forecast card. The governor map has no
 * chamber to control, so `midterms_maps` publishes no `control_event_ticker`
 * for it — this is the event the card's headline links to, the one whose volume
 * picks its forecast-accuracy row, and (like the two chamber-control events)
 * one the hub treats as a race in its own right.
 *
 * Lives here rather than in the midterms route dir because `queries/midtermsMaps`
 * needs it too, and a query module can't import from an app route.
 */
export const GOVERNOR_FORECAST_EVENT_TICKER = 'KXGOVWINS-27JAN01';
